<template>
  <div >
    <!-- 中间搜索UI -->
    <div class="middleSearch">
      <el-row>
        <el-col :span="8">
          <el-button type="primary" @click="showAddSingle">添加设备</el-button>
           <!-- <el-button type=""  @click="multiParams.multiSuccessVisible = true">批量添加</el-button> -->
          <el-button type=""  @click="multiParams.multiVisible = true">批量添加</el-button>
        </el-col>
        <el-col :span="16">
          <el-row type="flex" justify="end" :span="24">
          <el-select v-model="deviceSeachType" filterable placeholder="请选择" class="marr_10">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
                <!-- <el-button type="primary">全部</el-button>
                <el-button>禁用</el-button>
                <el-button>未分配</el-button> -->
              <el-col :span="8">
                <el-input autocomplete="on"  v-model.trim="deviceNameInputVal" placeholder="请输入设备名称" clearable class=""></el-input>
                <!-- <el-input  v-else v-model="nickNameInputVal" placeholder="请输入设备昵称" clearable class=""></el-input> -->
              </el-col>
              <el-button @click="getDeviceList('search')" type="primary" icon="el-icon-search" class="marl_10"></el-button>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <!-- 数据展示区域 -->
    <div class="showDataView">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          :selectable="selectable"
          type="selection"
          width="50">
        </el-table-column>
        <el-table-column
          prop="deviceName"
          label="设备名称"
          width="300">
          <template slot-scope="scope">{{ scope.row.deviceName? scope.row.deviceName : scope.row.nickName }}</template>
        </el-table-column>
        <el-table-column
          prop="productName"
          label="设备所属产品"
          width="150">
        </el-table-column>
        <el-table-column
          prop="name"
          label="状态/启用状态"
          width="150">
          <template slot-scope="scope">
            <div class="stateContent">
              <div :class="['dot',scope.row.btnState.class]"></div>
              {{scope.row.btnState.state}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="nodeType"
          label="节点类型">
          <template slot-scope="scope">
              {{scope.row.nodeType === 0? '直连设备' : scope.row.nodeType === 1 ? '网关子设备' : '网关设备'}}
          </template>
        </el-table-column>
        <el-table-column
          prop="lastOnlineTime"
          label="最后上线时间"
          width="300">
        </el-table-column>
        <el-table-column
          prop="address"
          label="操作"
          width="330"
          >
          <template slot-scope="scope">
            <!-- <div class="opreationBtn">
              <span class="detail" @click="linkDetail(scope.row)">查看详情</span>
              <span @click="enableChange(scope.row)" :class="scope.row.isEnable?'btnDisabled':'open'">{{scope.row.isEnable?'禁用':'启用'}}</span>
              <span class="del" @click="delDevice(scope.row)">删除</span>
            </div> -->
            <div style="text-align:left">
              <el-button
                size="mini"
                type="primary"
                class="check"
                @click="linkDetail(scope.row)">
                查看
              </el-button>
              <el-button
                @click="delDevice(scope.row)"
                size="mini"
                type="danger"
                style="margin-right:10px"
                slot="reference">
                删除
              </el-button>
              <el-button
                :disabled="scope.row.piIsEnable === false"
                @click="enableChange(scope.row)"
                v-if="scope.row.isEnable"
                size="mini"
                type="warning"
                slot="reference">
                禁用
              </el-button>
              <el-button
                @click="enableChange(scope.row)"
                v-else
                size="mini"
                type="success"
                slot="reference">
                启用
              </el-button>
              <el-button
                v-if="scope.row.nodeType === 2"
                @click="toSonDevice(scope.row)"
                size="mini"
                type="primary"
                slot="reference">
                子设备({{scope.row.subDeviceNum}})
              </el-button>
            </div>
           </template>

        </el-table-column>
      </el-table>

      <el-row :span="24" class="dataListOperation" type="flex" justify="space-between">
        <el-col :span="8">
          <el-button @click="delDevice()"><i class="el-icon-delete el-icon--left"></i>批量删除</el-button>
          <el-button @click="batchEnableChange('disable')"><i class="el-icon-folder-delete el-icon--left"></i>批量禁用</el-button>
           <el-button @click="batchEnableChange('enable')"><i class="el-icon-folder-checked el-icon--left"></i>批量启用</el-button>
          <!-- <el-button><i class="el-icon-pie-chart el-icon--left"></i>批量分配</el-button>
          <el-button><i class="el-icon-delete el-icon--left"></i>批量解除分配</el-button> -->
        </el-col>
        <el-col :span="14" >

          <!-- <el-row :span="24" type="flex" justify="end">
            <div class="showAll"> 共<span>{{total}}</span>个设备</div>
            <el-pagination
              layout="prev, pager, next"
              @current-change="currentPageChange"
              :current-page="listQuery.page"
              :page-size="listQuery.limit"
              :pager-count="9"
              :total="total">
            </el-pagination>
          </el-row> -->

          <Paging
              :total="total"
              pagingStatus=""
              @changePage="currentPageChange"/>
        </el-col>
      </el-row>
    </div>

     <!-- 添加单个设备弹出层 -->
     <addSingleDeviceView
     :singleAddDetail="singleAddDetail"
     @getDeviceList="getDeviceList('search')"
     @openSingleSuccessView="openSingleSuccessView"
     @closeView="singleVisible = false"
     :productList="productList"
      v-show="singleVisible"
      :singleVisible="singleVisible"/>

    <!-- 单个设备添加完成弹出层 -->
    <singleSuccessView
     v-show="singleSuccessVisible"
      @closeView="singleSuccessVisible=false"
      :singleSuccessVisible="singleSuccessVisible"
      :singleAddDetail="singleAddDetail"/>

    <!-- 批量添加设备弹出层 -->
    <addMultiDeviceView
      @getDeviceList="getDeviceList('search')"
      @openMultiSuccessView="multiParams.multiSuccessVisible = true"
      v-show="multiParams.multiVisible"
      @closeMulti="closeMulti"
       @closeView="multiParams.multiSuccessVisible = false"
      :productList="productList"
      :multiVisible="multiParams.multiVisible"
      :multiParams="multiParams"/>

    <!-- 多个设备添加完成弹出层 -->
    <multiSuccessView
      :multiParams="multiParams"
      v-show="multiParams.multiSuccessVisible"
      :multiSuccessVisible="multiParams.multiSuccessVisible"
      @closeView="multiParams.multiSuccessVisible = false"/>

  </div>
</template>
<script>
import { provinceData } from '@/assets/js/deviceManagerData'
import { deviceList, enableDevice, disableDevice, deleteDevice } from '@/api/deviceManagement'
import addSingleDeviceView from '@/components/deviceManage/addSingleDeviceView'
import singleSuccessView from '@/components/deviceManage/singleSuccessView'
import addMultiDeviceView from '@/components/deviceManage/addMultiDeviceView'
import multiSuccessView from '@/components/deviceManage/multiSuccessView'
import Paging from '@/components/paging'
import { mixin } from '@/mixins/mixin.js'
export default {
  mixins: [mixin],
  components: {
    addSingleDeviceView,
    singleSuccessView,
    addMultiDeviceView,
    multiSuccessView,
    Paging
  },
  props: ['productKey', 'deviceStatus', 'productList'],
  data () {
    return {
      // 选择区域用到的数据
      positionCurrentIndex: 1,
      provinceOptions: [],
      selProvinceValue: '',
      showListView: true, // 表示是否以列表形式显示
      // 中间搜索区域的数据
      seatchInputVal: '',
      // 设备列表展示
      tableData: [],
      multipleSelection: [],
      listQuery: {
        page: 1,
        limit: 10
      },
      total: 0,
      options: [
        {
          value: 'deviceName',
          label: '设备名称'
        }
      ],
      deviceSeachType: 'deviceName',
      deviceNameInputVal: '',
      nickNameInputVal: '',
      singleVisible: false,
      singleSuccessVisible: false,
      // 添加多个设备时相关参数
      multiParams: {
        multiVisible: false,
        addMultiProductKey: '',
        deviceNumTips: '单次最多添加1000台，系统会自动生成全局唯一的DeviceName',
        deviceNum: 0, // 添加成功得设备数量
        errorNum: 0, // 添加失败得设备数量
        multiSuccessVisible: false,
        url: ''// 下载设备证书的url
      },
      singleAddDetail: {
        deviceSecret: '',
        addSingleDetail: ''
      }
    }
  },
  methods: {
    selectable (row) {
      return row.piIsEnable
    },
    openSingleSuccessView () {
      console.log('调用了openSingleSuccessView')
      this.singleSuccessVisible = true
    },
    getProvinceOption () {
      const proviceArr = provinceData.rows
      this.provinceOptions = []
      let obj
      for (const key in proviceArr) {
        obj = { value: proviceArr[key].adcode, label: proviceArr[key].name }
        this.provinceOptions.push(obj)
      }
    },
    handleSelectionChange (val) {
      console.log('handleSelectionChange', val)
      this.multipleSelection = val
    },
    linkDetail (row) {
      console.log('row:', row)
      console.log('this.addSingleDetail:', this.addSingleDetail)
      this.$store.commit('SET_DEVICE_DETAIL', JSON.stringify(row))// 把设备详情缓存起来，很多地方用到,缓存成字符串，防止修改操作到对象
      // 命名路由传参类似于post，用name来识别和跳转
      this.$router.push({
        // name: 'hasParent/deviceManagement/DeviceManager',
        // params: row
        // path: 'deviceManagement/DeviceDetail',
        name: 'hasParent/deviceManagement/DeviceManager'
      })
    },
    getDeviceList (isSearch) {
      const params = {
        deviceStatus: this.deviceStatus,
        listType: 0, // 表示获取全部设备
        pageNumber: this.listQuery.page,
        pageSize: this.listQuery.limit,
        productKey: this.productKey
      }

      if (isSearch === 'search') {
        this.deviceSeachType === 'deviceName' ? params.deviceName = this.deviceNameInputVal : params.nickName = this.nickNameInputVal
        // 搜索时候把pageNumber重置为第一页
        params.page = 1
      }
      deviceList(params)
        .then(res => {
          res = res.data
          console.log(res)
          console.log('获取设备列表数据8888:', res)
          console.log('res.data设备：', res.data.data)
          const list = res.data.data
          this.total = res.data.total
          this.tableData = []
          if (JSON.stringify(list) !== 'null') {
            list.map((item, index) => {
            // console.log(item)
              item.lastOnlineTime = item.lastOnlineTime ? item.lastOnlineTime : '暂无记录'
              // item.status = item.isEnable && item.isActive && item.deviceStatus === 'ONLINE'
              // item.statusText = item.isEnable
              //   ? item.isActive
              //     ? ['在线', '离线']
              //     : ['已激活', '未激活']
              //   : ['启用', '禁用']
              // console.log('map中的对象this:', this)
              this.chagneStatus(item)
            })
          }
          console.log('then中的对象this:', this)
          this.tableData = list
        })
    },
    chagneStatus (item) {
      // ONLINE：在线。0
      // OFFLINE：离线。1
      // UNACTIVE：未激活。2
      // DISABLE：已禁用。3
      const stateParams = {
        0: 'ONLINE',
        1: 'OFFLINE',
        2: 'UNACTIVE',
        3: 'DISABLE'
      }
      const classParams = {
        0: 'online',
        1: 'offline',
        2: 'inactive',
        3: 'disabled'
      }
      const key = item.deviceStatus.toString()
      item.btnState = { isOpen: key === '0', state: stateParams[key], class: classParams[key] }
    },
    // 禁用启用单个
    enableChange (row) {
      const params = {
        deviceDTOS: [
          {
            deviceName: row.deviceName,
            productKey: row.productKey
          }
        ]
      }
      row.isEnable
        ? disableDevice(params).then(res => {
          res = res.data
          console.log('禁用返回：', res)
          row.isEnable = !row.isEnable
          this.chagneStatus(row)
          // 重新获取列表刷新
          this.getDeviceList()
        })
        : enableDevice(params).then(res => {
          res = res.data
          console.log('启用返回：', res)
          row.isEnable = !row.isEnable
          this.chagneStatus(row)
          // 重新获取列表刷新
          this.getDeviceList()
        })
    },
    // 批量禁用启用
    batchEnableChange (type) {
      const params = {
        deviceDTOS: this.multipleSelection.map(item => {
          return {
            deviceName: item.deviceName,
            productKey: item.productKey
          }
        })
      }
      console.log('批量params：', params)
      this.multipleSelection && this.multipleSelection.length > 0
        ? type === 'disable'
          ? disableDevice(params).then(res => {
            res = res.data
            console.log('批量禁用返回：', res)
            setTimeout(() => {
              // 重新获取列表刷新
              this.getDeviceList()
            }, 1000)
          })
          : enableDevice(params).then(res => {
            res = res.data
            console.log('批量启用返回：', res)
            setTimeout(() => {
              // 重新获取列表刷新
              this.getDeviceList()
            }, 1000)
          })
        : this.$message({
          type: 'info',
          message: '请先选择设备'
        })
    },
    delDevice (row) {
      this.$confirm('确定删除此设备?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        row
          ? this.confirmDel(row)
          : this.batchConfirmDel()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    confirmDel (row) {
      const params = {
        deviceDTOS: [
          {
            deviceName: row.deviceName,
            productKey: row.productKey
          }
        ]
      }
      deleteDevice(params).then(res => {
        res = res.data
        console.log('删除返回：', res)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.cutPage()// 比对删除的是否是最后一条，页数前移一页
        setTimeout(() => {
          // 重新获取列表刷新
          this.getDeviceList()
        }, 1000)
      })
    },
    // 批量删除
    batchConfirmDel () {
      const params = {
        deviceDTOS: this.multipleSelection.map(item => {
          return {
            deviceName: item.deviceName,
            productKey: item.productKey
          }
        })
      }
      console.log('批量删除params：', params)
      this.multipleSelection && this.multipleSelection.length > 0
        ? deleteDevice(params).then(res => {
          res = res.data
          console.log('批量删除返回：', res)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          if (this.listQuery.page !== 1 && this.multipleSelection.length === this.tableData.length) {
            console.log('全选了，页码减少1')
            this.listQuery.page--
          }
          setTimeout(() => {
          // 重新获取列表刷新
            this.getDeviceList()
          }, 1000)
        })
        : this.$message({
          type: 'info',
          message: '请先选择设备'
        })
    },
    //
    currentPageChange (listQuery) {
      // console.log('currentPageChange')
      // this.listQuery.page = num
      Object.assign(this.listQuery, {
        page: listQuery.page,
        limit: listQuery.limit
      })
      this.getDeviceList()
    },
    // 单个添加
    showAddSingle () {
      this.singleVisible = true
    },
    closeMulti () {
      this.multiParams.multiVisible = false
      console.log('关闭前回调')
      if (this.interval) {
        clearInterval(this.interval)
      }
    },
    toSonDevice (row) {
      console.log(row)
      this.$store.commit('SET_DEVICE_DETAIL', JSON.stringify(row))// 把设备详情缓存起来，很多地方用到,缓存成字符串，防止修改操作到对象
      // 命名路由传参类似于post，用name来识别和跳转
      this.$router.push({
        // name: 'hasParent/deviceManagement/DeviceManager',
        // params: row
        // path: 'deviceManagement/DeviceDetail',
        name: 'hasParent/deviceManagement/DeviceManager',
        params: {
          activeName: '7'
        }
      })
    }
  },
  mounted () {
    this.getProvinceOption()
  },
  created () {
    console.log('created')
    this.getDeviceList()
    // this.$router.push({
    //   name: 'hasParent/deviceManagement/DeviceManager'
    // })
    console.log('$httpCode:', this.$httpCode)
  },
  watch: {
    productKey () {
      console.log('productKey改变:', this.productKey)
      // 页码重置为1
      this.listQuery.page = 1
      // 重新刷新获取数据
      this.getDeviceList()
    },
    deviceStatus () {
      console.log('deviceStatus改变')
      // 重新刷新获取数据
      this.getDeviceList()
    }
  }
}
</script>
<style lang="less" scope>
html{
  background-color: #eaedf1;
}
.page-content {
  .marr_10{
    margin-right: 10px;
  }
  .marl_10{
    margin-left: 10px;
  }
  .middleSearch{
    background-color: white;
    padding-bottom: 10px;
  }
  .showDataView{
    background-color: white;
    .has-gutter{
       font-size: 16px;
        font-weight: bold;
        color: #33373c;
    }
    .cell{
      text-align: center;
    }
    .opreationBtn{
      .detail{
        color: #35a6df;
        cursor: pointer;
      }
      .btnDisabled{
        color: #ff090b;
         cursor: pointer;
      }
      .open{
        color: #138c4b;
         cursor: pointer;
      }
      span{
        margin-left: 20px;
      }
      .del{
        cursor: pointer;
      }
    }
    .onlineStatus{
      .online{
        color: #138c4b;
      }
      span{
        margin-left: 20px;
      }
    }
    .showAll{
      display: flex;
      align-items: center;
    }
    .dataListOperation{
      padding:20px 0;
    }

    .stateContent{
      display: flex;
      align-items: center;
      justify-content: center;
      .dot{
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin-right: 5px;
      }
      .disabled{
        background-color: #996262;
      }
      .inactive{
        background-color: #999062;
      }
      .offline{
        background-color: #888888;
      }
      .online{
        background-color: #1E8E39;
      }
    }

  }
  .el-dialog__body {
      padding: 0px 20px;
    }
    .check{
      margin-right: 10px;
    }
}
</style>
